import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  constructor(private http: HttpClient, private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('category/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('category/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('category/edit', val_id);
  }

  save(data:any) {
    return this.restService.save('category/save', data);
  }

  update(val_id: number, data:any) {
    return this.restService.update('category/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('category/delete', val_id);
  }

}
